import $ from 'jquery';

/**
 * Global Legacy & Modern Modal Fix
 * Handles BS3 (manual force) vs BS5 (instance-based hide)
 * included in the top of the main import files
 */
const forceCloseModal = function(input) {
    try {
        if (!input) return;
        let $modalEl;

        // Detect Input Type
        if (typeof input === 'string') {
            // It's a selector string
            $modalEl = $(input);
        } else if (input instanceof $) {
            // It's already a jQuery object
            $modalEl = input;
        } else if (input && input.modal) {
            // It's an instance object like event object
            $modalEl = $(input.modal);
        } else if (input && input.nodeType) {
            // It's a raw DOM element
            $modalEl = $(input);
        }

        if (!$modalEl || $modalEl.length === 0) {
            console.warn("forceCloseModal: No modal found for input:", input);
            return;
        }

        // --- Bootstrap 3 (Legacy) ---
        if ($modalEl.hasClass('in')) {

            // Try to find a dismiss button and click it to trigger native events
            const $closeBtn = $modalEl.find('[data-dismiss="modal"]').first();
            if ($closeBtn.length > 0) {
                $closeBtn.trigger('click');
            }

            // Immediate Brute Force Cleanup (no waiting for transitions)
            $modalEl.removeClass('in').hide();
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open').css('padding-right', '');
            $modalEl.trigger('hidden.bs.modal');// Manually trigger 'hidden' so Blade inline cleanup scripts run
        }

        // --- Bootstrap 5 ---
        else if ($modalEl.hasClass('show')) {
            if (window.bootstrap && bootstrap.Modal) {
                // Get or create the instance to use the official .hide() logic
                const b5Instance = bootstrap.Modal.getOrCreateInstance($modalEl[0]);
                if (b5Instance) {
                    b5Instance.hide();
                }
            } else {
                // Fallback for BS5 markup if JS is somehow missing
                $modalEl.removeClass('show').hide().modal('hide');
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
            }
        }
    } catch (e) {
        console.error("Modal close failed for " + input, e);
    }
};

window.app.fns.forceCloseModal = forceCloseModal;

export default forceCloseModal;

